import { HANDLE } from 'constants/bounding-box';

const BOUNDING_BOX_CONFIG = {
  customHandle: HANDLE.CORNERS,
};
const MIN_NR_ICONS = 1;
const MAX_NR_ICONS = 100;
const NR_OF_ICONS_DROPDOWN_OPTIONS = [5, 10, 50, 100];

const DEFAULT_SHAPE_COLOR_ONE = '#2B2B35';
const DEFAULT_SHAPE_COLOR_TWO = '#f64d2a';
const DEFAULT_NR_ICONS_NO_LABEL = 5;
const DEFAULT_NR_ICONS = 50;
const DEFAULT_GRID_ITEM_SIZE_PX = 42;
const DEFAULT_GRID_GAP_PX = 10;
const MAX_GAP_PX = 30;
const DEFAULT_MAX_SIZE_MONO = 80;
const DEFAULT_MAX_SIZE_COLOR = 160;

// TEMP: Icons8 illustrations that contain nested svg elements within g containers
//  These illustrations have paddings when viewBox is computed or render incorrectly within bbox
//  computeViewBox using getBBox doesn't work since there are nested svg tags within g tags, it will incorrect viewBox value
//  need to use their original viewBox to prevent clipping
const ICONS8_ILLUSTRATIONS_WITH_PADDINGS = [
  '64cb81949a65610b5c054a25',
  '60e4108ed2f2117e96dd13eb',
  '60d0521d6cdfe90eebf094da',
  '61361dadc5b118e811cdc6c0',
  '617854be4baf5b833c81db5e',
  '61ce82996be9e8f51edf620a',
  '61b0455e0a20d0886c3256f8',
  // '60e40a4766762fea9f9c5e06', // can't be fixed due to returned svg structure with incorrect transforms / positioning
  '61ce82f71a147cf5651d4d6e',
  '6087c6d84cc5e00008650b46',
  '609a2855a196788f0b409db7',
  '611249839ab05c8479d3a318',
  '61f170636f4c52b9294613fb',
  '61f170026a612794aa20cee9',
  '61b043a80a20d07ead325796',
  '64c3f97d29fa4a0001194149',
  '61c5eb59943798b7bab1207c',
  '60ae253bf055aa7468555f9d',
  '64c3f97729fa4a000119413e',
  '609e45333a714457e47f7181',
  '6086c18d239ae700106f81f8',
  '607d1e3b487a407bd8eea2cb',
  '6086c180a4da8c000eabba72',
];

export {
  BOUNDING_BOX_CONFIG,
  DEFAULT_GRID_GAP_PX,
  DEFAULT_GRID_ITEM_SIZE_PX,
  DEFAULT_MAX_SIZE_COLOR,
  DEFAULT_MAX_SIZE_MONO,
  DEFAULT_NR_ICONS,
  DEFAULT_NR_ICONS_NO_LABEL,
  DEFAULT_SHAPE_COLOR_ONE,
  DEFAULT_SHAPE_COLOR_TWO,
  ICONS8_ILLUSTRATIONS_WITH_PADDINGS,
  MAX_GAP_PX,
  MAX_NR_ICONS,
  MIN_NR_ICONS,
  NR_OF_ICONS_DROPDOWN_OPTIONS,
};
